import ApiClient from '../ApiClient';

class CrmFormsAPI extends ApiClient {
  constructor() {
    super('crm/forms', { accountScoped: true });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  embedCode(id) {
    return axios.get(`${this.url}/${id}/embed_code`);
  }

  submissions(id, params = {}) {
    return axios.get(`${this.url}/${id}/submissions`, { params });
  }

  generateLink(id, data = {}) {
    return axios.post(`${this.url}/${id}/generate_link`, data);
  }
}

export default new CrmFormsAPI();
